import React, {useContext} from "react";

import { Cart } from "../../cart";
import { Header, Title } from "./index.jsx";
import { SettingsContext } from "../../contexts";
import { FeatureGatingPopup } from "../../merchants";

const DefaultLayout = ({
    action,
    className,
    context,
    content,
    narrow,
    title,
    merchantHomeLink,
    type,
    withCart = true,
    wideContent = false,
    contentProps = {},
    ...props
}) => {
  const { isShopify, isRetailCircle, shopifyToken, merchantUuid } = useContext(SettingsContext);
  const Content = content

  let homeLink = undefined;
  if (isShopify && merchantHomeLink) {
    homeLink =`${merchantHomeLink}?shopify=${shopifyToken}&merchant=${merchantUuid}`;
  }

  return (
    <div id="default" className={`app-layout d-flex flex-column ${className === 'landing' ? 'black' : ''} ${wideContent ? 'wide-content' : ''}`}>
      <div className="app-content flex-grow-1 d-flex flex-column">
        {!isShopify && (props.withCategories || props.withSearch || props.topNavItems) && (
          <Header {...props} {...context} withCart={withCart} />
        )}

        {title && <Title narrow={narrow} merchantHomeLink={homeLink}>{title}</Title> }

        <Content
          className="flex-grow-1"
          action={action}
          type={type}
          {...contentProps}
          {...context}
        />
      </div>

      {isShopify && (
        <FeatureGatingPopup />
      )}

      {/* Product decision 2026-08-31: the black SimpleFooter and the legacy
          WhatsApp FAB (<ChatPrompt />) are removed from every page — the app
          chrome carries navigation, and support lives in the sidebar. */}
      {!isShopify && withCart && <Cart />}
    </div>
  );
}

export default DefaultLayout;
